'use client';
import React, { useState } from 'react';

import { NextImageProps } from '@/decodo/components/atoms/Image';
import { Modal } from '@/decodo/components/atoms/Modal';

import IconZoomIn from '~/svg/IconZoomIn.svg';

export interface ImageBlockProps {
  isExpandable: boolean;
  renderImage: (props?: Partial<NextImageProps>) => React.ReactNode;
}

export const ImageBlock = ({ isExpandable, renderImage }: ImageBlockProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div data-tracker-component='image-block' className='w-full'>
      <div className='shadow-tiny rounded dark:shadow-none relative mx-auto'>
        {renderImage()}
        {isExpandable && (
          <span className='hover:bg-gray-500 absolute left-6 top-6 flex h-12 w-12 cursor-pointer items-center justify-center rounded-full bg-gray-400 transition'>
            <IconZoomIn onClick={() => setIsOpen(true)} />
          </span>
        )}
      </div>
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        hasClose={false}
        classNames={{
          modal:
            'bg-transperant border-none shadow-none w-full animate-zoom-in md:w-3/4',
        }}
        dataTrackerSection='image-block'
      >
        {renderImage({ classNames: { image: 'w-full max-h-[600px]' } })}
      </Modal>
    </div>
  );
};
